/* unplugin-vue-components disabled */import script from "./mul-page-layout.vue?vue&type=script&setup=true&lang=js"
export * from "./mul-page-layout.vue?vue&type=script&setup=true&lang=js"

import "./mul-page-layout.vue?vue&type=style&index=0&id=57e17a82&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57e17a82"]])

export default __exports__